










import Vue from 'vue'

import NavItem from '@/components/NavItem.vue'
import { auth, firestore } from './firebase'
import { mapState } from 'vuex'

export default Vue.extend({
  components: { NavItem },
  data: () => {
    return {
      loading: true,
      navLinks: [
        { path: '/', text: 'Home' },
        { path: '/puzzle', text: 'Play' },
        { path: '/leaderboard', text: 'Leaderboard' }
        // { path: '/account', text: 'My Account' }
      ],
      unsubscribe: () => { }
    }
  },
  computed: {
    _navLinks () {
      return this.navLinks.filter(link => {
        return link.path !== this.$route.path
      })
    },
    ...mapState(['user'])
  },
  created () {
    auth().onAuthStateChanged(user => {
      if (user) {
        this.unsubscribe = firestore().doc(`users/${user.uid}`).onSnapshot(doc => {
          if (doc.exists) {
            const userData = doc.data()
            this.$store.commit('setUser', userData)
            this.loading = false
          }
        })

        if (['/login', '/register'].indexOf(this.$route.path) > -1) {
          this.$router.push('/')
        }
      } else {
        this.unsubscribe()
        this.$store.commit('setUser', { displayName: '', level: 0, points: 0 })
        if (['/login', '/register'].indexOf(this.$route.path) === -1) {
          this.$auth.logout()
        } else {
          this.loading = false
        }
      }
    })
  }
})
